import { Form, Table } from "@ster/ster-toolkit";
import { Form as AntForm } from "antd";
import { FormInstance } from "antd/lib/form";
import { TableProps } from "antd/lib/table";
import classNames from "classnames";
import { createContext, memo, useContext, useEffect, useMemo } from "react";

import { SubOrderRequest, UpdateFields } from "../../../../api";
import styles from "../SubOrderList.module.less";
import { EditableCellProps } from "./models";

const EditableContext = createContext<FormInstance | undefined>(undefined);

// Wijzigbare rij voor in de deelorderlijst
const EditableRow = ({ ...props }) => {
  const [form] = AntForm.useForm();

  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

// Wijzigbare cel om GRP's of budget van een deelorder te wijzigen
const EditableCell = ({
  dataIndex,
  children,
  editableColumn,
  expandableCell = true,
  record,
  onExpand,
  expandedItemKey,
  editable,
  className,
  isEditCampaign,
  ...restProps
}: EditableCellProps) => {
  const {
    editableCell: editableCellFn,
    onFormItem,
    renderEditor,
  } = editableColumn ?? {};
  const editableCell = editableCellFn?.(record) ?? false;

  const form = useContext(EditableContext);
  useEffect((): void => {
    // Vul het formulier met de bestaande deelorder
    if (form && editableCell) {
      form.setFieldsValue({
        [dataIndex]: record[dataIndex],
      });
    }
  }, [form, editableCell, dataIndex, record]);

  const editCell =
    editable &&
    editableCell &&
    expandedItemKey?.[0] !== record.id &&
    ((!isEditCampaign ||
      record.editableFields?.includes(UpdateFields.Budget)) ??
      false);
  const formItemProps = useMemo(
    () => onFormItem?.(record),
    [onFormItem, record]
  );

  return (
    <td
      // Maak de td klikbaar op alle niet-wijzigbare cellen om de rij uit te klappen
      onClick={(): void => {
        if (editable && record && !editableCell && expandableCell) {
          onExpand(expandedItemKey !== record.id, record.id);
        }
      }}
      className={classNames(className, {
        [styles.editableCell]: editableCell,
      })}
      {...restProps}
    >
      {editCell ? (
        <Form.Item name={dataIndex} {...formItemProps}>
          {renderEditor?.(record)}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

/**
 * Lijstweergave van deelorders met wijzigbare cel.
 */
const EditableTable = memo(({ ...props }: TableProps<SubOrderRequest>) => (
  <Table<SubOrderRequest>
    components={{
      body: {
        row: EditableRow,
        cell: EditableCell,
      },
    }}
    {...props}
  />
));

export default EditableTable;
